import axios from 'axios';
import auth from '@client/components/auth';
import { useEffect, useRef, useState } from 'react';
import { debounce, isEmpty } from 'lodash';

export type ExerciseSuggestion = {
  id: string;
  name: string;
  description: string;
};

export type ExerciseSuggestionsModel = {
  exerciseSuggestions: ExerciseSuggestion[];
};

export const useExerciseSuggestionsModel = (
  title: string,
): ExerciseSuggestionsModel => {
  const [exerciseSuggestions, setExerciseSuggestions] = useState<
    ExerciseSuggestion[]
  >([]);

  const debouncedSearch = useRef(
    debounce((title: string) => {
      console.debug(
        `Refetching suggestions from Search API for the phrase ${title}`,
      );

      axios
        .post(
          `${import.meta.env.VITE_SEARCH_API_URL}/exercise`,
          {
            query: title,
          },
          {
            headers: {
              Authorization: auth.getToken(),
            },
          },
        )
        .then((response) => {
          setExerciseSuggestions(
            response.data.results.map((exercise) => ({
              id: exercise.exercise_id,
              name: exercise.exercise_name,
              description: exercise.exercise_description,
            })),
          );
        });
    }, 250),
  ).current;

  useEffect(() => {
    debouncedSearch.cancel();

    if (isEmpty(title)) {
      setExerciseSuggestions([]);
      return;
    }

    debouncedSearch(title);
  }, [title]);

  return {
    exerciseSuggestions,
  };
};
